import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { StemPalette } from 'src/common/common.interface'

type StemPaletteState = {
  palettes: StemPalette[]
  currentPalette: StemPalette | null
  bestMatchPalette: StemPalette | null
  isLoadingStemPalette: boolean
}

const initialState: StemPaletteState = {
  palettes: [],
  currentPalette: null,
  bestMatchPalette: null,
  isLoadingStemPalette: false
}

const stemPaletteSlice = createSlice({
  name: 'stem-palette',
  initialState,
  reducers: {
    setPalettes: (state, action: PayloadAction<StemPalette[]>) => {
      state.palettes = action.payload
    },
    setCurrentPalette: (state, action: PayloadAction<StemPalette | null>) => {
      state.currentPalette = action.payload
      const index = state.palettes.findIndex((p) => p.id === action.payload?.id)
      if (index > -1 && action.payload) {
        state.palettes[index] = action.payload
      }
    },
    removePalette: (state, action: PayloadAction<StemPalette | null>) => {
      const index = state.palettes.findIndex((p) => p.id === action.payload?.id)
      if (index > -1 && action.payload) {
        state.palettes.splice(index, 1)
      }
    },
    setBestMatchPalette: (state, action: PayloadAction<StemPalette | null>) => {
      state.bestMatchPalette = action.payload
    },
    setIsLoadingStemPalette: (state, action: PayloadAction<boolean>) => {
      state.isLoadingStemPalette = action.payload
    }
  }
})

export const stemPaletteAction = stemPaletteSlice.actions

export default stemPaletteSlice.reducer
